var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#334368",
    fillRule: "evenodd",
    d: "M20 2C10.06 2 2 10.06 2 20s8.06 18 18 18 18-8.06 18-18S29.94 2 20 2zm0 4.2c7.62 0 13.8 6.18 13.8 13.8S27.62 33.8 20 33.8 6.2 27.62 6.2 20 12.38 6.2 20 6.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#334368",
    fillRule: "evenodd",
    d: "M19.9 9.6a2.1 2.1 0 0 0-2.1 2.1V21c0 .6.26 1.18.72 1.58l6.2 5.3a2.1 2.1 0 1 0 2.73-3.19L22 20.03v-8.33a2.1 2.1 0 0 0-2.1-2.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClock);
export default __webpack_public_path__ + "static/media/icon-clock.28623c81e93f1de97346c398f376860b.svg";
export { ForwardRef as ReactComponent };